module.exports = __webpack_public_path__ + "static/img/ab-join.66a61ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/abouts/ab-join.jpg
// module id = OxEH
// module chunks = 1